import { LookupGridComponent } from '../lookup-grid.component';
import { LookupGridDisplayType } from '../lookup-displaytype';
import { TreeTableComponent, TreeNode } from '@farris/ui-treetable';

export class UtilService {

    constructor(public instance: LookupGridComponent) {}


}
